module.exports = __webpack_public_path__ + "img/candle-holder.f5bd9cb7.svg";